import { handleCopy } from "@/components/common/commonFunction/handleCopy";
import { useEffect, useState } from "react";
import { FiCopy } from "react-icons/fi";
const placeHolderInitial = {
  startNumber: "1",
  increaseNumber: "2",
  totalNumber: "10",
  character: "+",
  output: "1 2 4 8 16 32 64 128 256 512",
};
export default function GeomatricSeries() {
  const [inputValue, setInputValue] = useState<any>({});
  const [placeHolder, setPlaceholder] = useState(placeHolderInitial);
  const [count, setCount] = useState([]);
  const [count1, setCount1] = useState([]);
  const [coma, setComa] = useState("  ");
  const [copy, setCopy] = useState(false);
  const [textValue, setTextValue] = useState("");
  const [errors, setErrors] = useState<any>({});

  const handleOnChange = (e) => {
    setTextValue("");
    if (e.target.value) {
      setPlaceholder({
        startNumber: "",
        increaseNumber: "",
        totalNumber: "",
        character: " ",
        output: "",
      });
    } else {
      setPlaceholder({
        startNumber: "1",
        increaseNumber: "2",
        totalNumber: "10",
        character: "+",
        output: "1 2 4 8 16 32 64 128 256 512",
      });
    }
    setCopy(false);
    const { name, value } = e.target;
    if (name === "character") {
      setComa(value);
    } else {
      setInputValue({ ...inputValue, [name]: value });
      setCount([]);
    }
    setErrors({ ...errors, [name]: "" });
  };

  useEffect(() => {
    if (count1) {
      const arrayToString = count1.toString();
      const formattedString = arrayToString.replace(/,/g, coma || " ");
      setTextValue(formattedString);
    }
  }, [count1, coma]);

  const handleOnSubmitArithmetic = () => {
    if (validateForm()) {
      setCopy(false);
      let increaseNumber = Number(inputValue.increaseNumber);
      let n = Number(inputValue.startNumber);
      let totalNumber = Number(inputValue.totalNumber);

      for (let i = 1; i <= totalNumber; i++) {
        count.push(n);
        n = n * increaseNumber;
      }
      setCount1(count);
    }
  };

  const validateForm = () => {
    let formIsValid = true;
    let err = {} as any;

    if (!inputValue?.startNumber) {
      err["startNumber"] = "* Please enter number";
      formIsValid = false;
    }
    if (!inputValue?.increaseNumber) {
      err.increaseNumber = "* Please enter number";
      formIsValid = false;
    }
    if (!inputValue?.totalNumber) {
      err.totalNumber = "* Please enter number";
      formIsValid = false;
    }
    setErrors(err);
    return formIsValid;
  };

  return (
    <>
      <div className="commom-box-new aritmetic-top-alignment">
        <div className="aritmetic-two-col-grid">
          <div className="aritmetic-two-col-grid-items">
            <div className="input-new"></div>

            <div className="input-new">
              <span>First term of the geometric progression.</span>
              <input
                type="number"
                name="startNumber"
                value={inputValue.startNumber}
                placeholder={placeHolder.startNumber}
                onChange={(e) => {
                  handleOnChange(e);
                }}
                className={errors?.startNumber && "error-input"}
              />

              <span className="text-sm text-red-700">
                {errors?.startNumber}
              </span>
            </div>
          </div>
          <div className="aritmetic-two-col-grid-items">
            <div className="input-new"></div>
            <div className="input-new">
              <span>Multiply the following value by this ratio.</span>
              <input
                type="number"
                name="increaseNumber"
                value={inputValue.increaseNumber}
                placeholder={placeHolder.increaseNumber}
                onChange={(e) => {
                  handleOnChange(e);
                }}
                className={errors?.increaseNumber && "error-input"}
              />
              <span className="text-sm text-red-700">
                {errors?.increaseNumber}
              </span>
            </div>
          </div>
          <div className="aritmetic-two-col-grid-items">
            <div className="input-new">
              <span>Number of elements in sequence.</span>
              <input
                type="number"
                name="totalNumber"
                value={inputValue.totalNumber}
                placeholder={placeHolder.totalNumber}
                onChange={(e) => {
                  handleOnChange(e);
                }}
                className={errors?.totalNumber && "error-input"}
              />
              <span className="text-sm text-red-700">
                {errors?.totalNumber}
              </span>
            </div>
          </div>
          <div className="aritmetic-two-col-grid-items">
            <div className="input-new">
              <span>
                Separate elements in the arithmetic sequence by this character.
              </span>
              <input
                type="text"
                name="character"
                onChange={handleOnChange}
                placeholder={placeHolder.character}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="button lowercase-center-alignment">
        <button onClick={handleOnSubmitArithmetic}>Genrate Now</button>
      </div>
      {textValue && (
        <div className="main-globally-counter-box">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(textValue)} />
            {copy && (
              <div>
                {" "}
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="counter-text-area">
            <textarea
              value={textValue}
              placeholder={placeHolder.output}
              disabled={true}
              className="text-black"
            />
          </div>
        </div>
      )}
    </>
  );
}
